import React, { useRef } from 'react';
import CommonToast from '@app/components/CommonToast';
import DialogPop from '@app/components/DialogPopup/dialogPop';
import { LoadingScreen } from '@app/components/Loading';
import { AppTopbarRef } from '@type/layout';
import { useMountEffect } from 'primereact/hooks';
import { classNames } from 'primereact/utils';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { AppFooter, AppSidebar, AppTopbar } from './components';

const DefaultLayout: React.FC = () => {
  const topbarRef = useRef<AppTopbarRef>(null);
  const layoutOverlay = useSelector((state: any) => state.layout.layoutOverlay);
  useMountEffect(() => {
    document.body.style.fontSize = '14px';
  });

  const containerClass = classNames('layout-wrapper', {
    'layout-overlay': layoutOverlay,
    'layout-static': !layoutOverlay,
    'layout-static-inactive': layoutOverlay,
    'layout-overlay-active': !layoutOverlay,
    'layout-mobile-active': !layoutOverlay,
    'p-input-filled': layoutOverlay,
    'p-ripple-disabled': layoutOverlay,
  });

  return (
    <>
      <div className={containerClass}>
        <DialogPop />
        <LoadingScreen />
        <CommonToast />
        <AppTopbar ref={topbarRef} />
        <AppSidebar />
        <div className="layout-main-container">
          <div className="layout-main">
            <Outlet />
          </div>
          <AppFooter />
        </div>
        {/* <AppConfig /> */}
        <div className="layout-mask" />
      </div>
    </>
  );
};

export default DefaultLayout;
